import React from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { registerTranslations } from '@/hooks/useTranslation';
import translations from './translations';
import EcommerceHero from '@/components/BusinessApps/EcommerceHero';
import EcommerceSolutions from '@/components/BusinessApps/EcommerceSolutions';
import EcommerceTechnology from '@/components/BusinessApps/EcommerceTechnology';
import EcommerceSelectionGuide from '@/components/BusinessApps/EcommerceSelectionGuide';
import EcommerceIntegration from '@/components/BusinessApps/EcommerceIntegration';
import EcommerceCallToAction from '@/components/BusinessApps/EcommerceCallToAction';

// Registriere seitenspezifische Übersetzungen
registerTranslations('eCommercePage', translations);

const ECommercePage = () => {
  return (
    <>
      <Seo 
        title="E-Commerce Plattformen für B2B & B2C - Maßgeschneiderte Shop-Lösungen" 
        description="Wir entwickeln zukunftssichere E-Commerce Plattformen für B2B & B2C. Maßgeschneidert, skalierbar und perfekt auf deine Geschäftsprozesse abgestimmt."
        canonical="/e-commerce"
      />
      <Layout>
        <main>
          <EcommerceHero />
          <EcommerceSolutions />
          <EcommerceTechnology />
          <EcommerceIntegration />
          <EcommerceSelectionGuide />
          <EcommerceCallToAction />
        </main>
      </Layout>
    </>
  );
};

export default ECommercePage; 